import { useState, useEffect } from "react";
import Axios from "axios";
import { useBaseUrl } from "../ApiContext";

const useWeeklyDietPlans = (userToken) => {
  const baseUrl = useBaseUrl();
  const [weeklyDietReports, setWeeklyDietReports] = useState([]);
  useEffect(() => {
    const fetchWeeklyPlans = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/weekly`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setWeeklyDietReports(response.data.reports);
      } catch (error) {
        console.log("Error during current weekly reports request", error);
      }
    };
    if (userToken) {
      fetchWeeklyPlans();
    }
  }, [baseUrl, userToken]);

  return { weeklyDietReports, setWeeklyDietReports };
};

export default useWeeklyDietPlans;
